(() => {
  const instances = new WeakMap();

  const getActiveIndex = (grid, cards) => {
    if (!cards.length) return 0;
    const gridCenter = grid.getBoundingClientRect().left + (grid.clientWidth / 2);
    return cards.reduce((closestIndex, card, index) => {
      const closestRect = cards[closestIndex].getBoundingClientRect();
      const closestDistance = Math.abs((closestRect.left + (closestRect.width / 2)) - gridCenter);
      const rect = card.getBoundingClientRect();
      const distance = Math.abs((rect.left + (rect.width / 2)) - gridCenter);
      return distance < closestDistance ? index : closestIndex;
    }, 0);
  };

  const initUseCases = (scope = document) => {
    scope.querySelectorAll('[data-use-cases]').forEach((section) => {
      if (instances.has(section)) return;

      const grid = section.querySelector('[data-media-gallery]');
      const dots = [...section.querySelectorAll('[data-strip-dot]')];
      const cards = [...section.querySelectorAll('.strip-card')];
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!(grid instanceof HTMLElement) || !cards.length || dots.length !== cards.length) return;

      let frame = 0;
      const updateDots = () => {
        frame = 0;
        const activeIndex = getActiveIndex(grid, cards);
        dots.forEach((dot, index) => {
          if (index === activeIndex) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };
      const handleScroll = () => {
        if (frame) return;
        frame = window.requestAnimationFrame(updateDots);
      };
      const handleDotClick = (event) => {
        const index = Number(event.currentTarget.dataset.stripDot);
        const card = cards[index];
        if (!card) return;
        grid.scrollTo({ left: card.offsetLeft, behavior: reducedMotion ? 'auto' : 'smooth' });
      };

      grid.addEventListener('scroll', handleScroll, { passive: true });
      dots.forEach((dot) => dot.addEventListener('click', handleDotClick));
      updateDots();

      instances.set(section, () => {
        grid.removeEventListener('scroll', handleScroll);
        dots.forEach((dot) => dot.removeEventListener('click', handleDotClick));
        if (frame) window.cancelAnimationFrame(frame);
      });
    });
  };

  const unloadUseCases = (scope) => {
    scope.querySelectorAll('[data-use-cases]').forEach((section) => {
      const cleanup = instances.get(section);
      if (cleanup) cleanup();
      instances.delete(section);
    });
  };

  document.addEventListener('DOMContentLoaded', () => initUseCases());
  document.addEventListener('shopify:section:load', (event) => initUseCases(event.target));
  document.addEventListener('shopify:section:unload', (event) => unloadUseCases(event.target));
})();
